import React from 'react'
import { useTranslation } from 'react-i18next'
import { MdClose, MdVolumeUp } from 'react-icons/md'
import styled from 'styled-components'

const Panel = styled.aside`
  position: fixed;
  z-index: ${({ theme }) => theme.layers.alwaysOnTop + 999};
  top: 132px;
  right: 24px;
  width: min(360px, calc(100vw - 24px));
  padding: 18px;
  border-radius: 16px;
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.borderColorPrimary};
  box-shadow: ${({ theme }) => theme.shadows.xl};

  @media (max-width: 768px) {
    top: auto;
    right: 12px;
    bottom: calc(12px + env(safe-area-inset-bottom, 0px));
  }
`

const Heading = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-weight: 700;

  svg {
    flex: 0 0 auto;
    font-size: 23px;
    color: ${({ theme }) => theme.colors.accentColor};
  }
  span {
    flex: 1;
  }
  button {
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
  }
`

const Description = styled.p`
  margin: 10px 0 16px;
  line-height: 1.45;
  font-size: 0.9rem;
`

const Activate = styled.button`
  width: 100%;
  min-height: 42px;
  border: 0;
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.accentColor};
  color: #fff;
  font-weight: 700;
  cursor: pointer;
`

export function VoiceSoundPrompt({ onActivate, onDismiss }: { onActivate: () => void; onDismiss: () => void }) {
  const { t } = useTranslation()
  return (
    <Panel role="status" aria-live="polite">
      <Heading>
        <MdVolumeUp aria-hidden="true" />
        <span>{t('translation:voice.ringtone.promptTitle')}</span>
        <button type="button" onClick={onDismiss} aria-label={t('translation:voice.ringtone.dismiss')}>
          <MdClose />
        </button>
      </Heading>
      <Description>{t('translation:voice.ringtone.promptDescription')}</Description>
      <Activate type="button" onClick={onActivate}>
        {t('translation:voice.ringtone.activateBeforeCall')}
      </Activate>
    </Panel>
  )
}
